export default function UIStepBlurp({ ico, title, description, customwidth = 300 }) {
    return (
        <div style={{ display: 'flex', width: customwidth, padding:'4em 0em', flexDirection: 'column', alignItems: 'center', margin:'auto' }}>
            <img alt='blur' style={{ height: '30px', marginBottom: "1.5rem" }} src={ico} />
            <div style={{ fontSize: '20px', marginBottom: '10px', fontFamily: 'Scotia-Bold', color: "#EC111A" }}>{title}</div>
            <div style={{ textAlign: 'center', fontSize: '16px', width: '80%',height:"80px" }}>{description}</div>
        </div >
    )
}